// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__YiyXF","link":"HeaderSimple_link__LQyrX","inputSearch":"HeaderSimple_inputSearch__S0GdX"};